const getKeyword = keyword =>
  keyword === 'Restaurants' ? 'Places to Eat' : keyword;

const LISTVIEW_SECONDARY_HEADING = ({ keyword, suburb, state, postcode }) => {
  return `Top ${suburb} ${state}${postcode ? ` ${postcode}` : ''} ${getKeyword(
    keyword
  )}`;
};

export default LISTVIEW_SECONDARY_HEADING;
